import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import MeshBackground from 'react-scale/components/elements/webgl';
import CTA from 'react-scale/components/elements/cta';
import styles from 'react-scale/components/pages/text/hero/hero.module.css';
import Classification from 'react-scale/components/pages/text/hero/examples/Classification';
import MLDataCollection from 'react-scale/components/pages/text/hero//examples/MLDataCollection';
import MLTranscription from 'react-scale/components/pages/text/hero//examples/MLTranscription';
import NamedEntityRecognition from 'react-scale/components/pages/text/hero//examples/NamedEntityRecognition';

const Slider = dynamic(() => import('react-scale/components/pages/text/hero/Slider'), {
  loading: () => <div className="hero-text-slider" />, // eslint-disable-line react/display-name
  ssr: false
});

const Hero = ({ overtitle, title, subtitle, cta, bgAnimated }) => {
  const [activeSlide, setActiveSlide] = React.useState(1);

  return (
    <section className="relative text-white bg-black">
      {bgAnimated && <MeshBackground />}
      <div className="container relative">
        <div className={`${styles.mainGrid} grid gap-6 lg:gap-10 items-center py-8`}>
          <header>
            <h4 className="inline-block mb-6 text-overtitle-sm text-gradient">{overtitle}</h4>
            <h1 className="mb-6 text-4xl font-light font-aeonik lg:text-5xl">{title} </h1>
            <p className="w-full text-lg">{subtitle}</p>
            <div className="mt-8">
              <CTA cta={cta} />
            </div>
          </header>

          <div className={`${styles.sliderWrapper} bg-new-gradient md:rounded-lg py-12`}>
            <Slider updateActiveSlide={setActiveSlide}>
              <div className={`${styles.slide} bg-white rounded-lg h-full w-full`}>
                <MLTranscription animate={activeSlide === 0} />
              </div>
              <div className={`${styles.slide} bg-white rounded-lg h-full w-full`}>
                <NamedEntityRecognition animate={activeSlide === 1} />
              </div>
              <div className={`${styles.slide} bg-white rounded-lg h-full w-full`}>
                <Classification animate={activeSlide === 2} />
              </div>
              <div className={`${styles.slide} bg-white rounded-lg h-full w-full`}>
                <MLDataCollection animate={activeSlide === 3} />
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  bgAnimated: PropTypes.bool
};

Hero.defaultProps = {
  bgAnimated: true
};

export default Hero;
